import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { FacebookCommentsInterface } from 'common/types/entities/FacebookCommentsInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createFacebookComments = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): FacebookCommentsInterface => {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.FacebookComments,
      parentId,
      masterBlockId,
    ),
    delay: 0,
    href: '',
    numPosts: 5,
  }
}
